import React, { useState, useEffect } from 'react';
import './AgeVerification.css';

const AgeVerification = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isVerified = localStorage.getItem('ageVerified');
    if (!isVerified) {
      setShowModal(true);
    }
  }, []);

  const handleVerify = (isOver18) => {
    if (isOver18) {
      localStorage.setItem('ageVerified', 'true');
      setShowModal(false);
    } else {
      window.location.href = 'https://www.google.com';
    }
  };

  if (!showModal) return null;

  return (
    <div className="age-verification-overlay">
      <div className="age-verification-modal">
        <h2 className="age-verification-title">Age Verification</h2>
        <p className="age-verification-text">
          You must be 18 years or older to access this website.
        </p>
        <p className="age-verification-question">
          Are you 18 years of age or older?
        </p>
        <div className="age-verification-buttons">
          <button 
            onClick={() => handleVerify(true)}
            className="btn btn-primary btn-lg"
          >
            Yes, I'm 18+
          </button>
          <button 
            onClick={() => handleVerify(false)}
            className="btn btn-secondary btn-lg"
          >
            No, I'm under 18
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;